import { Component, inject } from '@angular/core';
import { SupervisionSessionService } from '../../services/supervision-session.service';

@Component({
  selector: 'app-supervision-banner',
  standalone: true,
  templateUrl: './supervision-banner.component.html',
  styleUrl: './supervision-banner.component.scss',
})
export class SupervisionBannerComponent {
  protected readonly supervision = inject(SupervisionSessionService);

  protected finish(): void {
    // No llama /auth/logout: la sesión normal y sus cookies permanecen separadas.
    this.supervision.finish();
  }
}
